import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, ref, watch, onBeforeUnmount, defineAsyncComponent } from 'vue';
import { useRouter } from 'vue-router';
import { useAiAccess } from '@/helpers/composables/useAiAccess';
import { openRoomRoute } from '@/helpers/open-room-route';

export default /*@__PURE__*/_defineComponent({
  __name: 'BotRoomButton',
  props: {
    beginner: { type: Boolean },
    withFriend: { type: Boolean },
    unavailableText: {},
    busyText: {},
    loadingText: {},
    errorText: {},
    disabled: { type: Boolean },
    color: {},
    variant: {},
    hideIcon: { type: Boolean },
    inlineErrors: { type: Boolean }
  },
  emits: ["opened", "selected", "busy", "availability", "error"],
  setup(__props: any, { emit: __emit }) {

const BotGameSetup = defineAsyncComponent(() => import(/* webpackChunkName: "bot-game-setup" */ './BotGameSetup.vue'));
const props = __props;
const emit = __emit;
const router = useRouter();
const { canPlay, accessStatus, botModes, ownRoomID } = useAiAccess();
const busy = ref(false);
const setupOpen = ref(false);
let active = true;
onBeforeUnmount(() => {
  active = false;
});
const availability = computed(() =>
  canPlay.value &&
  (ownRoomID.value ||
    (props.beginner
      ? botModes.value.beginner
      : botModes.value.smart || botModes.value.regular || botModes.value.beginner))
    ? 'available'
    : accessStatus.value === 'ready'
      ? 'unavailable'
      : accessStatus.value,
);
watch(availability, (value) => emit('availability', value), { immediate: true });
function setBusy(value: boolean) {
  busy.value = value;
  emit('busy', value);
}
async function openRoom() {
  if (!active || busy.value || props.disabled) return;
  emit('selected');
  if (!ownRoomID.value) {
    setupOpen.value = true;
    return;
  }
  setBusy(true);
  try {
    if (await openRoomRoute(router, ownRoomID.value, () => active)) emit('opened');
  } finally {
    if (active) setBusy(false);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_btn, {
      class: "bot-room-button",
      color: _ctx.color || 'secondary',
      variant: _ctx.variant || 'flat',
      size: "large",
      elevation: 0,
      disabled: busy.value || !!_ctx.disabled,
      loading: busy.value,
      onClick: openRoom
    }, {
      default: _withCtx(() => [
        (!_ctx.hideIcon)
          ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 0,
              icon: "smart_toy",
              size: "20",
              class: "mr-2",
              "aria-hidden": "true"
            }))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString(_ctx.$t('aiArena.botPlay')), 1)
        ])
      ]),
      _: 3
    }, 8, ["color", "variant", "disabled", "loading"]),
    (setupOpen.value)
      ? (_openBlock(), _createBlock(_unref(BotGameSetup), {
          key: 0,
          modelValue: setupOpen.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((setupOpen).value = $event)),
          beginner: _ctx.beginner,
          "with-friend": _ctx.withFriend,
          onBusy: setBusy,
          onError: _cache[1] || (_cache[1] = ($event: any) => (emit('error', $event))),
          onOpened: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('opened')))
        }, null, 8, ["modelValue", "beginner", "with-friend"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})